export interface SparklineProps {
  values: Array<number | null>;
  width?: number;
  height?: number;
  color?: string;
  ariaLabel?: string;
}

export function Sparkline(props: SparklineProps): SVGElement {
  const width = props.width ?? 100;
  const height = props.height ?? 18;
  const values = props.values.filter((v): v is number => v != null && Number.isFinite(v));
  const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
  svg.setAttribute('width', String(width));
  svg.setAttribute('height', String(height));
  svg.setAttribute('viewBox', `0 0 ${width} ${height}`);
  svg.setAttribute('role', 'img');
  svg.setAttribute('aria-label', props.ariaLabel ?? 'Спарклайн тренда');
  svg.classList.add('spark');
  if (values.length < 2) {
    const text = document.createElementNS('http://www.w3.org/2000/svg', 'text');
    text.textContent = values.length === 0 ? '—' : '•';
    text.setAttribute('x', String(width / 2));
    text.setAttribute('y', String(height / 2 + 4));
    text.setAttribute('text-anchor', 'middle');
    text.setAttribute('fill', 'var(--text-tertiary)');
    text.setAttribute('font-size', '11');
    svg.appendChild(text);
    return svg;
  }
  const min = Math.min(...values);
  const max = Math.max(...values);
  const range = max - min || 1;
  const xStep = values.length > 1 ? width / (values.length - 1) : 0;
  const points: string[] = [];
  for (let i = 0; i < values.length; i++) {
    const x = i * xStep;
    const y = height - ((values[i]! - min) / range) * (height - 4) - 2;
    points.push(`${x.toFixed(1)},${y.toFixed(1)}`);
  }
  const polyline = document.createElementNS('http://www.w3.org/2000/svg', 'polyline');
  polyline.setAttribute('points', points.join(' '));
  polyline.setAttribute('fill', 'none');
  polyline.setAttribute('stroke', props.color ?? 'currentColor');
  polyline.setAttribute('stroke-width', '1.5');
  polyline.setAttribute('stroke-linecap', 'round');
  polyline.setAttribute('stroke-linejoin', 'round');
  svg.appendChild(polyline);
  const lastX = (values.length - 1) * xStep;
  const lastY = height - ((values[values.length - 1]! - min) / range) * (height - 4) - 2;
  const lastDot = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
  lastDot.setAttribute('cx', lastX.toFixed(1));
  lastDot.setAttribute('cy', lastY.toFixed(1));
  lastDot.setAttribute('r', '2');
  lastDot.setAttribute('fill', props.color ?? 'currentColor');
  svg.appendChild(lastDot);
  return svg as unknown as SVGElement;
}
